{
  "zh-TW": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "你有未儲存的變更，關閉後將會遺失。"
        }
      }
    }
  }
}
